import { useMutation } from "react-query";

import { useApiClient } from "api/useApiClient";

export type DeleteAppointmentV2Args = {
  hcProfId: number;
  appointmentId: number;
};

export const useDeleteAppointmentV2 = () => {
  const client = useApiClient();

  return useMutation<null, Error, DeleteAppointmentV2Args>({
    mutationFn: args => client.deleteAppointmentV2(args),
  });
};
